// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1332":"ab79cfd529552e53","1748":"3f2354923a5f114d"}[chunkId] + ".css";
};